import {Component, Input, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {ExemptionCommonComponent} from '../exemption_common/exemption_common.component';
import {
  DangerInformation,
  Exemption,
  Exemption_TypeVessel,
  Vessel
} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-visit-exemptions-exemption-base',
    templateUrl: './exemption_base.component.html',
    styleUrls: ['./exemption_base.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionBaseComponent {

  @ViewChild(ExemptionCommonComponent, { static: true }) exemptionCommonComponent!: ExemptionCommonComponent;

  @Input() considering: string;
  @Input() name: string;

  exemption: Exemption;

  vesselTypes: Exemption_TypeVessel[] = [null, Exemption_TypeVessel.IMO, Exemption_TypeVessel.ENI];

  vesselTypesFormatter = (vesselType: Exemption_TypeVessel) => {
    switch (vesselType) {
      case "IMO":
        return 'IMO';
      case "ENI":
        return 'ENI';
    }
  };

  vesselNameFormatter = (vessel: Vessel) => {
    return vessel.name + ' – ' + vessel.imoCode;
  };

  onVesselChangeWithPrefix(prefix: String, vessel: Vessel) {
    this.exemption[prefix + 'VesselNameIMO'] = vessel?.name;
    this.exemption[prefix + 'VesselIMO'] = vessel?.imoCode;
  }

  onVesselChange(vessel: Vessel) {
    this.exemption['vesselNameIMO'] = vessel?.name;
    this.exemption['vesselIMO'] = vessel?.imoCode;
  }

  onDangerousGoodsChange(dangerousGoods: DangerInformation) {
    this.exemption['substanceName'] = dangerousGoods?.name;
    this.exemption['unVnNumber'] = dangerousGoods?.unCode;
  }

  splitConsidering(): string[] {
    return (this.considering && this.considering != '') ? this.considering.split(/\r?\n/)
      .filter(considering => considering) : ['']
  }
}
